module.exports = __webpack_public_path__ + "static/media/delishop-favicons.f80fae37.png";